<template>
  <div class="cartcontrol">
    <transition name="move">
      <div class="cart-decrease" @click.stop.prevent="decreaseCart" v-show="food.count">
        <!-- @click.stop.prevent 事件修飾符 -->
        <!-- Vue.js 提供的事件修飾符有下面這幾個:

                .stop : 停止觸發上層 DOM 元素事件。

                .prevent : 避免瀏覽器預設行為。

                .capture : 不管觸發事件的目標是否是下層， 設定 capture 的事件一定會先觸發。

                .self : 只有觸發此 DOM 元素本身才會觸發 self 事件。

                .once : 此事件只觸發一次。

                .passive : 無視 prevent 功能。 -->

        <span class="inner icon-remove_circle_outline"></span>
      </div>
    </transition>
    <div class="cart-count" v-show="food.count">{{ food.count }}</div>
    <div class="cart-add icon-add_circle" @click.stop.prevent="addCart">
      <i class="bg"></i>
    </div>
  </div>
</template>
<script>
  import Vue from "vue"

  export default {
    props: {
      food:{
        type:Object
      }
    },
    methods: {
      decreaseCart(){
        this.food.count--
      },
      addCart(){
        // this.food.count++
        // (不能這樣寫)

        if (!this.food.count){
          Vue.set(this.food,'count',1)
        }else{
          this.food.count++
        }
      }
    }
  }
</script>
<style>
  @import url("Cartcontrol.css");
</style>



// WEBPACK FOOTER //
// src/components/Cartcontrol/Cartcontrol.vue